import { DatasetFilterPayload, H3Configuration } from "./dataset";

export enum WidgetType {
  BAR_V = "BAR_VERTICAL",
  BAR_H = "BAR_HORIZONTAL",
  DONUT = "DONUT",
  LINE = "LINE",
  BIG_NUMBER = "BIG_NUMBER"
}

export enum OrderByType {
  ASC = "ASC",
  DESC = "DESC"
}

export enum AggregationType {
  COUNT = "COUNT",
  SUM = "SUM",
  AVG = "AVG",
  MIN = "MIN",
  MAX = "MAX",
  MEDIAN = "MEDIAN",
  DISTINCT_COUNT = "DISTINCT_COUNT"
}

export interface PostWidgetAnalysisConfigPayload {
  id: string;
  dimension: string;
  measure?: string;
  aggregation?: AggregationType;
  order_by?: OrderByType;
  filters?: DatasetFilterPayload[];
  grid_config?: {
    level?: number;
    aggregation_type?: string;
  };
  group_by?: string;
}

export interface WidgetDefaultConfiguration {
  dataset_id: string;
  label: string;
  chart_type: WidgetType;
  dimension: string;
  measure: string;
  aggregation: AggregationType; // COUNT, SUM, AVG, MIN, MAX, MEDIAN
  configuration: {
    dimension_values_shown: number; // line_shown, bar_shown, slice_shown
    order_by: OrderByType;
  };
  h3Configuration?: H3Configuration | null;
  group_by?: string;
}

export interface PostWidgetDefaultConfigPayload {
  id: string;
  grid_config?: { aggregation_type: string };
  group_by?: string;
}

export interface PostWidgetDefaultConfigResponse {
  data: WidgetDefaultConfiguration;
}

export interface WidgetConfig extends WidgetDefaultConfiguration {
  widget_id: string; // with extra suffix `_n`
}

export type WidgetConfigWithoutWidgetId = Omit<WidgetConfig, "widget_id">;

export interface WidgetMap {
  [id: string]: WidgetConfig;
}
export interface AnalysisDataPoint {
  label: string;
  value: number;
}

export interface WidgetAnalysisConfigResult {
  aggregation?: string;
  dimension: string;
  measure: string;
  data?: AnalysisDataPoint[];
  rows?: Record<string, string | number>[];
  value?: number;
}

export interface PostWidgetAnalysisResponse {
  data: WidgetAnalysisConfigResult;
}

export type WidgetPreviewData =
  | WidgetAnalysisConfigResult["data"]
  | WidgetAnalysisConfigResult["rows"]
  | { type: AggregationType; value: number; measure: string }[];
